import * as React from 'react';

import { cn } from '../../../lib/utils';
import { describeEta, type EtaUrgency } from './etaFormat';

// No warning token in the design system, so "due soon" uses an explicit amber hue;
// normal = brand, overdue = destructive.
const URGENCY_HEADLINE: Record<EtaUrgency, string> = {
  normal: 'text-(--brand-600)',
  soon: 'text-[#b45309]',
  overdue: 'text-destructive',
};

export interface EtaDisplayProps {
  /** ISO-8601 UTC ETA. */
  iso: string;
  className?: string;
}

/**
 * Option C ETA display: a relative headline ("Arriving in 3 days" / "Overdue by
 * 2 hours") over the exact viewer-local stamp, colored by urgency. Shared by the
 * admin picker trigger and the brand read-only cell — the admin "tap to edit"
 * affordance lives on the trigger button (native title tooltip), not here.
 */
export function EtaDisplay({ iso, className }: EtaDisplayProps) {
  const { relative, exact, urgency } = describeEta(iso);
  return (
    <span className={cn('flex flex-col text-left leading-tight', className)}>
      <span className={cn('text-body-sm-medium', URGENCY_HEADLINE[urgency])}>{relative}</span>
      <span className="text-caption-regular text-muted-foreground">{exact}</span>
    </span>
  );
}
